export interface LayoutPreset {
  name: string;
  expression: string;
  sections: number;
}

export const LAYOUT_PRESETS: Record<string, LayoutPreset> = {
  L1:   { name: 'Single section',       expression: '1',                    sections: 1 },
  L2V:  { name: 'Two vertical',         expression: 'V[1,2]',               sections: 2 },
  L2H:  { name: 'Fanlight over main',   expression: 'H[1,2]',               sections: 2 },
  L3V:  { name: 'Triptych',             expression: 'V[1,2,3]',             sections: 3 },
  L3H:  { name: 'Stacked',              expression: 'H[1,2,3]',             sections: 3 },
  L3T2: { name: 'Transom + 2 below',    expression: 'H[1,V[2,3]]',          sections: 3 },
  L4G:  { name: 'Grid 2x2',             expression: 'H[V[1,2],V[3,4]]',     sections: 4 },
  L4V:  { name: 'Four vertical',        expression: 'V[1,2,3,4]',           sections: 4 },
  L4T3: { name: 'Transom + 3 below',    expression: 'H[1,V[2,3,4]]',        sections: 4 },
  L5T4: { name: 'Transom + 4 below',    expression: 'H[1,V[2,3,4,5]]',      sections: 5 },
  L6G:  { name: 'Grid 3x2',             expression: 'H[V[1,2,3],V[4,5,6]]', sections: 6 },
  L6T5: { name: 'Transom + 5 below',    expression: 'H[1,V[2,3,4,5,6]]',    sections: 6 },
};
